interface props {
  labelName: string;
  value?: any;
  options: any;
  setInputText: Function;
  disabled?: any;
  defaultValue?: any;
}
const DropDown = ({
  labelName,
  value,
  options,
  setInputText,
  disabled,
  defaultValue
}: props) => {
  const onHandleChange = (e: any) => {
    if (e.target.value) {
      setInputText(JSON.parse(e.target.value));
    }
  };
  const onChangeClear = () => {
    setInputText("");
  };  
  return (
    <select
      className="form-select"
      aria-label="Default select example"
      onChange={onHandleChange}
      disabled={disabled}
      value={value ? JSON.stringify(value) : ""}
      defaultValue={defaultValue}
    >
      <option value="" selected disabled>
        {labelName}
      </option>
      {options?.length > 0
        ? options?.map((item: any) => {
          return (
            <option key={item?._id} value={JSON.stringify(item)}>
              {item?.percentage ? item?.percentage : item?.name}
            </option>
          );
        })
        : null}
    </select>
  );
};

export default DropDown;
